import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { debounceTime, delay, fromEvent } from 'rxjs';
import {LabelToggleComponent} from "../label-toggle/label-toggle.component";
import {CommonModule} from "@angular/common";
import {TooltipDirective} from "../../../shared/tooltip/tooltip.directive";
import {FormsModule} from "@angular/forms";
import {ReplacePipe} from "../../../../pipes/replace.pipe";
@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  standalone: true,
  imports: [
    CommonModule,
    LabelToggleComponent,
    TooltipDirective,
    FormsModule,
    ReplacePipe
  ],
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent implements AfterViewInit, OnInit {
  public id: string;
  @Input() unit?: string;
  @Input() label?: string;
  @Input() hasInlineLabel: boolean = false;
  @Input() labelWidth?: string;
  @Input() inputWidth?: string;
  @Input() description: string = '';
  @Input() placeholder: string = '';
  @Input() textAlign?: 'right' | 'center' | 'left' = 'left';
  @Input() pattern: RegExp = /(.*)+/;
  @Input() val?: any | undefined;
  oldVal?: any;
  @Output() valChange = new EventEmitter<any>();
  @Input() hasToggleLabel: boolean = false;
  @Input() important?: boolean;
  @Input() importantStyle: 'checkbox' | 'point' | 'important' = 'point';
  @Input() forceLabel?: boolean;
  @Input() disabled: boolean = false;
  @Input() disabledInput: boolean = false;
  @Input() readonly: boolean = false;
  @Input() multiline?: boolean;
  @Input() delay: number = 100;
  @Input() type: 'string' | 'integer' | 'float' | 'listIntegers' = 'string';
  @Input() inputType: 'password' | 'email' | 'number' | 'date' | 'text' =
    'text';
  @Output() importantChange = new EventEmitter<boolean>();
  @Output('enter') enterChange = new EventEmitter<boolean>();
  @ViewChild('input') inputEl?: ElementRef;

  @HostBinding('class.has-inline-label') hasInlineLabelClass: boolean = false;
  constructor() {
    this.id = uuidv4();
  }

  ngAfterViewInit() {
    if (this.inputEl) {
      fromEvent(this.inputEl.nativeElement, 'keydown')
        .pipe(debounceTime(this.delay))
        .subscribe(() => {
          this.onInputValChange();
        });
    }
  }

  ngOnInit() {
    this.hasInlineLabelClass = this.hasInlineLabel;
  }

  onClickReset() {
    this.val = undefined;
    this.valChange.emit(this.val);
  }
  onInputValChange() {
    if (!this.val?.length) {
      this.valChange.emit(this.val);
      return;
    }
    if (this.type == 'float' || this.type == 'integer') {
      if (this.val.length == 1 && this.val.indexOf('-') === 0) return;
      if (this.val.length == 2 && this.val.indexOf('-0') === 0) return;
      if (this.val.indexOf('.') === this.val.length - 1) {
        this.valChange.emit(this.val.replace(/.$/, ''));
        return;
      }
    }
    if (this.type == 'listIntegers') {
      this.val = this.val.replace('  ', ' ');
    }
    this.valChange.emit(this.val);
  }

  onKeyDown(event: any) {
    const k = event.key;
    const sk = event.shiftKey;
    const val = this.val?.toString();
    if (this.isEnter(k)) {
      this.enterChange.emit(true);
    }
    if (this.isBackspace(k) || this.isArrow(event.keyCode) || this.isSuppr(k))
      return;
    if (this.type == 'integer') {
      if (this.isSpace(k)) {
        event.preventDefault();
      }
      if (this.isNumber(k)) return;
      event.preventDefault();
    }
    if (this.type == 'float') {
      if (this.isSpace(k)) {
        event.preventDefault();
      }
      if (this.isMinus(k) && val?.includes('-')) {
        event.preventDefault();
      }
      if (this.isDot(k) && val?.includes('.')) {
        event.preventDefault();
      }
      if (this.isNumber(k) || this.isDot(k)) return;
      event.preventDefault();
    }

    if (this.type == 'listIntegers') {
      if (this.isSpace(k) && this.val?.length > 0) return;
      if (this.isMinus(k) || this.isNumber(k)) return;
      event.preventDefault();
    }
  }

  isBackspace(key: string) {
    return key == 'Backspace';
  }

  isMinus(key: string) {
    return key == '-';
  }

  isSuppr(key: string) {
    return key == 'Delete';
  }

  isSpace(key: string) {
    return key == ' ';
  }

  isArrow(keycode: number) {
    return keycode >= 37 && keycode <= 40;
  }

  isNumber(key: any) {
    return key >= 0 && key <= 9;
  }

  isDot(key: string) {
    return key == '.';
  }

  isEnter(key: string) {
    return key == 'Enter';
  }

  onImportantChange($event: boolean) {
    this.important = $event;
    this.importantChange.emit(this.important);
  }
}
